// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/bgmap2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page{
  background: linear-gradient(180deg, #FFFFFF 0%, #E7E7E7 100%);
}

#why {
  scroll-margin-top: 250px;
}

#home, #what, #leadership, #products {
  scroll-margin-top: 90px;
}

.landing-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.hero-background {
  color: white;
  position: relative;
  overflow: hidden;
  overflow-x: hidden;
  padding-top: 10px; /* Add padding to accommodate fixed navbar */
}

.landing-navbar {
  padding: 1rem 0;
  background-color: transparent !important;
  transition: background-color 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

.landing-navbar.scrolled {
  padding: 0.5rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* Styles for navbar when there are no messages (white background) */

.landing-navbar.no-messages .navbar-brand {
  color: #000 !important;
}

.landing-navbar.no-messages .main-nav .nav-link {
  color: #000 !important;
}

.landing-navbar.no-messages .main-nav .nav-link:hover,
.landing-navbar.no-messages .main-nav .nav-link.active {
  color: #000 !important;
}

.landing-navbar.no-messages .login-btn {
  background: transparent !important;
  border: 2px solid #000 !important;
  color: #000 !important;
}

.landing-navbar.no-messages .login-btn:hover {
  background: #000 !important;
  color: white !important;
  border-color: #000 !important;
}

.navbar-container {
  max-width: 1140px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.mapka-logo {
  height: 50px !important;
  width: auto;
}

.logo-text {
  font-size: 32px;
  font-weight: 600;
  margin-left: 10px;
  color: white;
}

/* Custom logo styling for the navbar */
.navbar-brand {
  font-size: 28px;
  font-weight: 600;
  color: white !important;
  display: flex;
  align-items: center;
}

.navbar-brand .logo-m {
  background: linear-gradient(90deg, #ffffff 0%, #132775 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
  margin-right: 2px;
}

.navbar-brand .logo-text {
  color: white;
  font-weight: 400;
  text-transform: lowercase;
}

.main-nav {
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-nav .nav-link {
  color: white;
  margin: 0 1.5rem;
  padding: 0.5rem 0;
  padding-left: 0 !important;
  position: relative;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  font-weight: 400;
  font-size: 16px;
  text-decoration: none;
}

.main-nav .nav-link:hover, 
.main-nav .nav-link.active {
  opacity: 1;
  color: white !important;
  font-weight: 400;
  text-decoration: none;
}

.main-nav .nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 50%;
  background-color: white;
  border-radius: 5px;
}

.nav-buttons {
  display: flex;
  gap: 15px;
}

.waitlist-btn {
  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%);
  border: none !important;
  border-radius: 100px !important;
  transition: background-color 0.3s ease, scale 1s ease;
  font-weight: 600;
  font-size: 18px;
}

.waitlist-btn:hover {
  scale: 1.05;
}

.login-btn {
  background: transparent !important;
  border: 2px solid white !important;
  color: white !important;
  border-radius: 100px !important;
  font-weight: 500;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: white !important;
  color: #132775 !important;
  border-color: white !important;
}

.hero-section {
  padding: 8rem 0 4rem;
  position: relative;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
}

.powered-by {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  opacity: 0.8;
}

.powered-by span {
  margin-right: 10px;
  font-size: 14px;
}

.nysora-logo {
  height: 20px;
  width: auto;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  line-height: 1.2;
}

.hero-description {
  font-size: 1.5rem;
  opacity: 0.8;
  margin-bottom: 4rem;
  line-height: 1.4;
  font-weight: 400;
}

.scroll-indicator {
  display: flex;
  align-items: center;
  opacity: 0.6;
  font-size: 14px;
  gap: 10px;
}

.hero-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.laptop-mockup {
  position: absolute;
  scale: 0.75;
  z-index: 1;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.why-description {
  font-size: 1.25rem;
  line-height: 1.6;
  color: #555;
}

.landing-footer {
  padding: 2rem 0;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.landing-footer a {
  color: #6c757d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.landing-footer a:hover {
  color: #007bff;
}

@media (max-width: 1400px) {
  .navbar-container {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .main-nav .nav-link {
    font-size: 16px;
    margin-right: 1.2rem;
  }
  .nav-buttons .waitlist-btn,
  .nav-buttons .login-btn {
    font-size: 16px;
    padding: 0.4rem 1.2rem;
  }
}

@media (max-width: 1200px) {
  .navbar-container {
    flex-wrap: wrap;
    gap: 0rem;
  }
  .main-nav .nav-link {
    font-size: 16px;
    margin-right: 0.6rem;
  }
  .nav-buttons .waitlist-btn,
  .nav-buttons .login-btn {
    font-size: 16px;
    padding: 0rem 0rem;
  }
}

@media (max-width: 991px) {
  .main-nav {
    margin-left: 0;
    margin-bottom: 1rem;
  }
  
  .main-nav .nav-link {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
  
  .nav-buttons {
    width: 100%;
    justify-content: center;
    margin-top: 1rem;
  }
  
  .hero-section {
    padding: 4rem 0 3rem;
    text-align: center;
  }
  
  .logo, .powered-by {
    justify-content: center;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-description {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }
  
  .scroll-indicator {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .section-header {
    flex-direction: column;
  }
  
  .section-header h2 {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .section-divider {
    width: 100%;
  }
}

.klaviyo-form-section {
  padding: 4rem 0;
  background-color: #f8f9fa;
}

.klaviyo-form-container {
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.klaviyo-form-container h3 {
  font-weight: 600;
  color: #30353C;
  font-size: 2rem;
}

.klaviyo-form-container p {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Klaviyo form styling overrides */
#klaviyo-form-embed .klaviyo-form {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

#klaviyo-form-embed input[type="email"] {
  border: 2px solid #e9ecef !important;
  border-radius: 12px !important;
  padding: 1rem 1.25rem !important;
  font-size: 1rem !important;
  transition: border-color 0.3s ease !important;
}

#klaviyo-form-embed input[type="email"]:focus {
  border-color: #2F80ED !important;
  box-shadow: 0 0 0 0.2rem rgba(47, 128, 237, 0.15) !important;
  outline: none !important;
}

#klaviyo-form-embed button[type="submit"] {
  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%) !important;
  border: none !important;
  border-radius: 100px !important;
  padding: 1rem 2.5rem !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  transition: transform 0.2s ease !important;
  margin-top: 1rem !important;
}

#klaviyo-form-embed button[type="submit"]:hover {
  transform: translateY(-1px) !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .klaviyo-form-container {
    padding: 2rem 1.5rem;
    margin: 1rem;
  }
  
  .klaviyo-form-container h3 {
    font-size: 1.5rem;
  }
  
  .klaviyo-form-container p {
    font-size: 1rem;
  }
}

.hero-orbit-bg {
  position: absolute;
  top: 60%;
  left: 50%;
  width: 80vw;
  max-width: 900px !important;
  min-width: 400px;
  transform: translate(-50%, -50%) scale(0.6);
  z-index: 2;
  pointer-events: none;
  opacity: 0.7;
}

.hero-background {
  position: relative;
  overflow: hidden;
}

.scroll-indicator-vertical {
  position: fixed;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  pointer-events: none;
}

.scroll-dots {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dot {
  width: 8px;
  height: 8px;
  background: #D9D9D9;
  border-radius: 50%;
  opacity: 0.7;
  transition: background 0.3s, opacity 0.3s, transform 0.4s cubic-bezier(0.4,0,0.2,1);
}

@media (max-width: 991px) {
  .scroll-indicator-vertical {
    display: none;
  }
}

.indicator-line {
  width: 8px;
  height: 110px;
  background: #D9D9D9;
  border-radius: 6px;
  margin: 2px 0;
  opacity: 1;
  transition: background 0.3s, height 0.3s, transform 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.3s;
}

.why-mapka-section {
  width: 100%;
  background: #30353C;
  display: flex;
  justify-content: center;
}

.why-mapka-title {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}

.why-mapka-divider {
  width: 100%;
  max-width: 120px; /* or whatever length you want */
  height: 2px;
  background: #fff; /* or your divider color */
}

.why-mapka-text {
  font-size: 22px;
  color: #fff;
  margin: 0;
  font-weight: 400;
}

.section-dots-divider {
  border-top: 2px solid rgba(227, 227, 227, 1);
  width: 100%;
  opacity: 0.7;
}

@media (max-width: 900px) {
  .why-mapka-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .why-mapka-title {
    margin: 0 0 1.5rem 0;
  }
  .why-mapka-divider {
    width: 100%;
    margin: 0 0 1.5rem 0;
    height: 2px;
  }
  .why-mapka-text {
    max-width: 100%;
  }
}

.what-section {
  background: #30353C;
  padding: 0rem 0 0rem 0;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.what-title-bg-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  z-index: 1;
}

.what-title-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  font-size: 79px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1;
  letter-spacing: 0px;
  text-align: center;
}

.painpoint-cards-row {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
}

.painpoint-card {
  border-radius: 20px;
  color: #fff;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 2rem;
  min-height: 320px;
  border: 1px solid #949494;
  transition: box-shadow 0.2s;
  backdrop-filter: blur(40px);
}
.painpoint-card:hover {
  box-shadow: 0 8px 32px rgba(47,128,237,0.12);
}
.painpoint-top {
  font-size: 16px;
  font-weight: 400;
  opacity: 0.85;
  margin-bottom: 2.5rem;
  min-height: 48px;
}
.painpoint-bottom {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  justify-content: flex-start;
  flex-grow: 0;
}
.painpoint-mapka-logo {
  height: 32px;
  width: auto;
  margin-right: 0.5rem;
}
.painpoint-mapka-text {
  font-size: 16px;
  font-weight: 500;
  color: #2F80ED;
}
.mapka-logo-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.painpoint-solution {
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  margin: 0;
  align-self: flex-start;
  line-height: 1.4;
}
.mapka-map-overlay-text {
  color: #fff;
}
@media (max-width: 1200px) {
  .painpoint-cards-row {
    gap: 1.2rem;
  }
  .painpoint-card {
    min-width: 170px;
    max-width: 300px;
    padding: 1.3rem 1rem 1rem 1rem;
  }
}
@media (max-width: 900px) {
  .painpoint-cards-row {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
  .painpoint-card {
    width: 100%;
    max-width: 420px;
    min-width: 0;
  }
  .what-section {
    padding: 2.5rem 0 2rem 0;
  }
  .what-title {
    font-size: 2rem;
  }
  .what-title-bg {
    font-size: 9vw;
  }
}

.what-chaos-to-clarity {
  font-size: 22px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  margin-bottom: 4.5rem;
  z-index: 2;
  position: relative;
}

.gray-circles-right {
  position: absolute;
  bottom: 35%;
  right: 0;
  z-index: 1;
  width: auto;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.gray-circles-img {
  max-width: 320px !important;
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}
@media (max-width: 900px) {
  .gray-circles-img {
    max-width: 160px;
  }
}

.what-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3rem;
}
.what-image-col {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 70%;
}
.what-mobiles-img {
  width: 100%;
  height: auto;
  scale: 1.5;
}
.what-text-col {
  flex: 1 1;
  color: #fff;
  padding-left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 30%;
}
.what-text-col h2 {
  font-size: 40px;
  font-weight: 700;
  text-align: right;
}
.what-text-col p {
  font-size: 18px;
  font-weight: 400;
  text-align: right;
  max-width: 450px;
}
@media (max-width: 900px) {
  .what-content-row {
    flex-direction: column;
    gap: 2rem;
    padding: 0 0 0 0;
  }
  .what-image-col {
    justify-content: center;
    margin-bottom: 1.5rem;
  }
  .what-text-col {
    padding-left: 0;
    text-align: center;
  }
  .what-mobiles-img {
    max-width: 90vw;
  }
}

.leadership-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}
.leadership-image-col {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.leadership-mobiles-img {
  max-width: 380px;
  width: 100%;
  height: auto;
  border-radius: 32px;
  box-shadow: 0 8px 32px rgba(47,128,237,0.10);
}
.leadership-text-col {
  flex: 1 1;
  color: #fff;
  padding-left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.leadership-text-col h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
}
.leadership-text-col p {
  font-size: 1.25rem;
  line-height: 1.7;
  color: #e0e0e0;
}
@media (max-width: 900px) {
  .leadership-content-row {
    flex-direction: column;
    gap: 2rem;
    padding: 0 1rem;
  }
  .leadership-image-col {
    justify-content: center;
    margin-bottom: 1.5rem;
  }
  .leadership-text-col {
    padding-left: 0;
    text-align: center;
  }
  .leadership-mobiles-img {
    max-width: 90vw;
  }
}

.what-title-divider-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 3rem;
}
.what-title-divider-group .why-mapka-divider {
  width: 100px;
  max-width: 100%;
  margin-right: 1rem;
}

.leadership-creed-section {
}

.leadership-creed-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2.5rem;
  padding: 0 2rem;
}
.leadership-creed-text-col {
  flex: 1 1;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 480px;
}
.leadership-creed-title {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 1.5rem;
}
.leadership-creed-desc {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 1.5rem;
  color: #fff;
}
.leadership-creed-guiding {
  font-size: 20px;
  font-weight: 400;
  margin-top: 1.5rem;
}
.leadership-creed-guiding span {
  color: #fff;
  font-weight: 500;
}
.leadership-creed-image-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}
.leadership-creed-img {
  max-width: 100%;
  height: auto;
  z-index: 2;
  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
}
.leadership-creed-name-title {
  margin-top: 2.5rem;
  text-align: right;
  width: 100%;
}
.leadership-creed-name {
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
}
.leadership-creed-role {
  font-size: 1rem;
  color: #e0e0e0;
  margin-top: 0.2rem;
}
@media (max-width: 900px) {
  .leadership-creed-row {
    flex-direction: column;
    gap: 2rem;
    padding: 0 0 0 0;
  }
  .leadership-creed-image-bg {
    width: 220px;
    height: 220px;
  }
  .leadership-creed-img {
    width: 200px;
  }
  .leadership-creed-name-title {
    margin-top: 1.2rem;
    text-align: center;
  }
  .leadership-creed-text-col {
    max-width: 100%;
    text-align: center;
  }
}

.human-first-section {
  text-align: center;
}
.human-first-title {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.5rem;
}
.human-first-subtitle {
  color: #fff;
  font-size: 20px;
  margin-bottom: 3.5rem;
}
.human-first-features-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 2.5rem;
  margin: 0 auto;
  max-width: 1200px;
}
.human-first-feature {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;
  max-width: 300px;
}
.human-first-icon-bg {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: #232733;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  backdrop-filter: blur(10px);
  box-shadow: 0px 1px 50px 1px #2F80ED;
  position: relative;
}
.human-first-icon {
  color: #1a6cff;
  font-size: 3rem;
}
.human-first-feature-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.human-first-feature-desc {
  color: #e0e0e0;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
}
@media (max-width: 900px) {
  .human-first-features-row {
    flex-direction: column;
    gap: 2.5rem;
    align-items: center;
  }
  .human-first-feature {
    max-width: 100%;
  }
  .human-first-icon-bg {
    width: 120px;
    height: 120px;
    margin-bottom: 1.2rem;
  }
  .human-first-icon {
    font-size: 2.2rem;
  }
}

.products-section {
}
.products-title {
  text-align: center;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 4rem;
}
.products-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 4rem 4rem;
  margin: 0 auto;
}
.products-stat {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  gap: 2.5rem;
  width: 100%;
}
.products-stat-number {
  font-size: 145px;
  font-weight: 300;
  color: #fff;
  text-align: right;
  width: 50%;
}
.products-stat-plus {
  font-size: 60px;
  vertical-align: super;
  font-weight: 400;
}
.products-stat-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
}
.products-stat-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1rem;
}
.products-stat-desc {
  font-size: 16px;
  color: #fff;
  font-weight: 400;
}

@media (max-width: 900px) {
  .products-title {
    font-size: 32px;
  }
  .products-stats-grid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
    gap: 2.5rem 0;
  }
  .products-stat {
    gap: 1.5rem;
  }
  .products-stat-number {
    font-size: 80px;
    min-width: 60px;
  }
  .products-stat-title {
    font-size: 18px;
  }
  .products-stat-desc {
    font-size: 14px;
  }
}

.mapka-footer {
  color: #fff;
  padding: 60px 0 30px 0;
  position: relative;
  margin-top: 0;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  position: relative;
}

.footer-brand {
  display: flex;
  align-items: center;
  flex: 1 1 180px;
  margin-bottom: 30px;
}

.footer-logo {
  max-width: 200px !important;
  height: 50px !important; 
  margin-right: 12px;
}
.footer-links {
  display: flex;
  flex: 3 1 600px;
  gap: 60px;
  flex-wrap: wrap;
}

.footer-col {
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-col-title {
  color: #b0b3b8;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 22px;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  font-size: 22px;
  font-weight: 500;
  line-height: 50px;
  margin-bottom: 2px;
  transition: color 0.2s;
}

.footer-link:hover {
  opacity: 0.8;
}

.footer-newsletter {
  flex: 2 1 300px;
  min-width: 260px;
}

.footer-newsletter-title {
  color: #868686;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 22px;
}

.footer-newsletter-form {
  display: flex;
  align-items: center;
}

.footer-newsletter-input {
  width: 100%;
  padding: 10px 16px;
  border-radius: 24px;
  border: none;
  background: #484b4e;
  color: #fff;
  font-size: 1rem;
  outline: none;
}

.footer-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-row-top {
  margin-bottom: 40px;
}

.footer-row-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}

.footer-scroll-top-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
}

.footer-scroll-top {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-scroll-top svg {
  display: block;
  width: 70px;
  height: 70px;
}

.footer-scroll-top-label {
  color: #fff;
  font-size: 1.1rem;
  margin-top: 18px;
  text-align: center;
  opacity: 0.95;
}

.footer-scroll-top:hover svg circle {
  fill: #3996d2;
  transition: fill 0.2s;
}

@media (max-width: 900px) {
  .footer-row,
  .footer-row-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }
  .footer-scroll-top {
    align-self: flex-end;
    margin-top: 20px;
  }
}

.footer-copyright {
  width: 100%;
  margin: 48px 0 0 0;
  padding-bottom: 32px;
}

.footer-copyright-divider {
  border: none;
  border-top: 1.5px solid #5a5d60;
  margin: 0 auto 32px auto;
  width: 100%;
  opacity: 0.4;
}

.footer-copyright-text {
  color: #b0b3b8;
  text-align: center;
  font-size: 16px;
  opacity: 0.7;
  font-weight: 400;
}

.early-access-hero {
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 90vw;
  margin: 0 auto 60px auto;
  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%);
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
}

.early-access-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.early-access-left {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.early-access-title {
  color: #fff;
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 24px;
}

.early-access-desc {
  color: #eaf6ff;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 40px;
}

.early-access-buttons {
  display: flex;
  gap: 24px;
}

.early-access-btn {
  border: none;
  border-radius: 100px;
  font-size: 18px;
  font-weight: 600;
  padding: 18px 44px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.early-access-btn.primary {
  background: #fff;
  color: #2D9BE1;
  font-size: 18px;
  padding: 18px 66px !important;
}

.early-access-btn.primary:hover {
  background: rgba(255,255,255,0.2);
  color: #fff;
}

.early-access-btn.secondary {
  background: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 18px;
}

.early-access-btn.secondary:hover {
  background: rgba(255,255,255,0.3);
}

.early-access-right {
  position: absolute !important;
  right: 0;
  bottom: 0;
  height: auto;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  pointer-events: none;
}

.early-access-graphic {
  max-width: 320px;
  width: 100%;
  height: auto;
  min-width: 120px;
  min-height: 120px;
  max-height: 100%;
}

@media (max-width: 700px) {
  section{
    padding: 0rem 1rem 0rem 1rem;
  }
  .early-access-hero {
    min-height: 420px;
    padding-bottom: 120px;
  }
  .hero-section {
    padding: 0 0 2rem 0;
    min-height: 100vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    position: relative;
    z-index: 1;
  }
  .mobile-hero-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 16px 0 16px;
    position: relative;
    z-index: 3;
    background: transparent;
  }
  .mobile-logo {
    display: flex;
    align-items: center;
    height: 40px;
  }
  .mobile-logo .mapka-logo {
    height: 40px !important;
    width: auto;
  }
  .mobile-hero-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 0;
    position: relative;
    z-index: 2;
  }
  .mobile-scroll-indicator {
    margin-top: 5rem;
    text-align: center;
    z-index: 2;
    position: relative;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  .mobile-hero-image {
    margin: 18px 0 0 0;
    display: flex;
    justify-content: center;
    z-index: 1;
    position: relative;
    width: 100%;
  }
  .mobile-hero-image .laptop-mockup {
    height: auto;
    position: static;
    scale: 1.2;
  }
  .mobile-hero-content {
    margin: 18px 0 0 0;
    text-align: center;
    z-index: 2;
    position: relative;
    padding: 0 0 0 0;
    width: 100%;
  }
  .mobile-hero-content .powered-by {
    justify-content: center;
    margin-bottom: 1.2rem;
    margin-top: 0;
    padding-top: 0 !important;
  }
  .mobile-hero-content .hero-title {
    font-size: 22px;
    margin-bottom: 1rem;
  }
  .mobile-hero-content .hero-description {
    font-size: 16px;
    margin-bottom: 1.5rem;
  }
  .powered-by span{
    font-size: 12px;
  }
  .powered-by img{
    height: 12px;
  }
  .painpoint-card{
    max-width: 333px;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    margin-bottom: 0;
  }
  .hero-orbit-bg {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100vw;
    min-width: 600px;
    max-width: 100vw;
    height: 100vh;
    transform: translateX(-50%);
    z-index: 2;
    opacity: 0.5;
    pointer-events: none;
  }
  .what-title-divider-group h2{
    font-size: 22px;
  }
  .what-text-col{
    width: 100%;
  }
  .what-text-col p{
    text-align: left;
  }
  .what-title-divider-group h2{
    text-align: left;
  }
  .what-mobiles-img{
    scale: 1.4;
    margin-top: 1rem;
  }
  .leadership-creed-row{
    margin-top: 1rem;
  }
  .leadership-creed-title{
    font-size: 22px;
    text-align: left;
  }
  .leadership-creed-desc{
    font-size: 16px;
    text-align: left;
  }
  .leadership-creed-guiding{
    font-size: 16px;
    text-align: left;
  }
  .leadership-creed-img{
    scale: 1.55;
  }
  .leadership-creed-section .section-dots-divider{
    margin-top: 5rem !important;
  }
  .human-first-title{
    font-size: 22px;
  }
  .human-first-subtitle{
    font-size: 16px;
  }
  .human-first-features-row{
    margin-top: 1rem;
  }
  .products-title{
    font-size: 22px;
  }
  .products-stat-number{
    display: flex;
    justify-content: center;
    width: 33% !important;
  }
  .mapka-map-image-wrapper{
    margin-top: 1rem;
  }
  .early-access-right{
    justify-content: flex-end;
  }
  .early-access-title{
    font-size: 22px;
    text-align: center;
  }
  .early-access-desc{
    font-size: 16px;
  }
  .logo {
    display: none !important;
  }
  .landing-navbar .navbar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    overflow-x: hidden;
    box-sizing: border-box;
  }
  .landing-navbar {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    padding: 0.5rem 0;
  }
  .why-mapka-title{
    font-size: 22px;
  }
  .why-mapka-divider{
    display: none;
  }
  .why-mapka-text{
    font-size: 16px;
  }
  .what-chaos-to-clarity{
    font-size: 16px;
  }
  .mapka-map-image {
    box-shadow: 0 0 0 0 #30353C;
    border-radius: 30px;
    position: relative;
    z-index: 1;
    /* Side fade using pseudo-elements */
  }
  .mapka-map-overlay-text {
    z-index: 3;
    color: #fff;
    border-radius: 18px;
    padding: 0 0 0 0;
  }
  .mapka-map-overlay-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 10px;
    letter-spacing: 0.5px;
  }
  .mapka-map-overlay-desc {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #e0e0e0;
  }
  .early-access-content{
    padding: 40px 10px 10px 10px;
  }
  .early-access-buttons {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  .early-access-right {
    position: absolute !important;
    right: 0;
    bottom: 0;
    width: 35vw;
  }
  .early-access-graphic {
    max-width: 100%;
    min-width: 80px;
    min-height: 80px;
  }
  .early-access-left {
    align-items: center;
    text-align: center;
  }
  .early-access-title {
    text-align: center;
  }
  .early-access-desc {
    text-align: center;
  }
  .early-access-buttons {
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 3rem;
  }
  .footer-newsletter{
    flex: none;
  }
  .footer-col-title{
    font-size: 18px;
  }
  .footer-link{
    font-size: 16px;
  }
}
@media (max-width: 700px) {
  .mapka-map-overlay-text {
    top: 10px;
    left: 10px;
    max-width: 90vw;
    padding: 0 0 0 0;
  }
  .mapka-map-overlay-title {
    font-size: 1.1rem;
  }
  .mapka-map-overlay-desc {
    font-size: 0.95rem;
  }
}

.bg-map-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

@media (max-width: 991px) and (min-width: 701px) {
  section{
    padding: 0rem 1rem 0rem 1rem;
  }
  .early-access-hero {
    min-height: 420px;
    padding-bottom: 120px;
  }
  .hero-section {
    padding: 0 0 2rem 0;
    min-height: 100vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    position: relative;
    z-index: 1;
  }
  .mobile-hero-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 16px 0 16px;
    position: relative;
    z-index: 3;
    background: transparent;
  }
  .mobile-logo {
    display: flex;
    align-items: center;
    height: 40px;
  }
  .mobile-logo .mapka-logo {
    height: 40px !important;
    width: auto;
  }
  .mobile-hero-stack {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 0;
    position: relative;
    z-index: 2;
  }
  .mobile-scroll-indicator {
    margin-top: 5rem;
    text-align: center;
    z-index: 2;
    position: relative;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  .mobile-hero-image {
    margin: 18px 0 0 0;
    display: flex;
    justify-content: center;
    z-index: 1;
    position: relative;
    width: 100%;
  }
  .mobile-hero-image .laptop-mockup {
    height: auto;
    position: static;
    scale: 1;
  }
  .mobile-hero-content {
    margin: 18px 0 0 0;
    text-align: center;
    z-index: 2;
    position: relative;
    padding: 0 0 0 0;
    width: 100%;
  }
  .mobile-hero-content .powered-by {
    justify-content: center;
    margin-bottom: 1.2rem;
    margin-top: 0;
    padding-top: 0 !important;
  }
  .mobile-hero-content .hero-title {
    font-size: 24px;
    margin-bottom: 1rem;
  }
  .mobile-hero-content .hero-description {
    font-size: 18px;
    margin-bottom: 1.5rem;
  }
  .powered-by span{
    font-size: 13px;
  }
  .powered-by img{
    height: 12px;
  }
  .painpoint-card{
    max-width: 333px;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    margin-bottom: 0;
  }
  .hero-orbit-bg {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100vw;
    min-width: 600px;
    max-width: 100vw;
    height: 100vh;
    transform: translateX(-50%);
    z-index: 2;
    opacity: 0.5;
    pointer-events: none;
  }
  .what-title-divider-group h2{
    font-size: 22px;
  }
  .what-text-col{
    width: 100%;
    align-items: center !important;
  }
  .what-text-col p{
    text-align: left;
  }
  .what-title-divider-group h2{
    text-align: left;
  }
  .what-mobiles-img{
    scale: 1.4;
    margin-top: 4rem;
  }
  .leadership-creed-row{
    margin-top: 1rem;
  }
  .leadership-creed-title{
    font-size: 24px;
    text-align: left;
  }
  .leadership-creed-desc{
    font-size: 18px;
    text-align: left;
  }
  .leadership-creed-guiding{
    font-size: 18px;
    text-align: left;
  }
  .leadership-creed-img{
    scale: 1.85;
  }
  .leadership-creed-section .section-dots-divider{
    margin-top: 5rem !important;
  }
  .human-first-title{
    font-size: 24px;
  }
  .human-first-subtitle{
    font-size: 18px;
  }
  .human-first-features-row{
    margin-top: 1rem;
  }
  .products-title{
    font-size: 24px;
  }
  .products-stat-number{
    display: flex;
    justify-content: center;
    width: 33% !important;
  }
  .mapka-map-image-wrapper{
    margin-top: 1rem;
  }
  .early-access-right{
    justify-content: flex-end;
  }
  .early-access-title{
    font-size: 24px;
    text-align: center;
  }
  .early-access-desc{
    font-size: 18px;
  }
  .logo {
    display: none !important;
  }
  .landing-navbar .navbar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    overflow-x: hidden;
    box-sizing: border-box;
  }
  .landing-navbar {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    padding: 0.5rem 0;
  }
  .why-mapka-title{
    font-size: 24px;
  }
  .why-mapka-divider{
    display: none;
  }
  .why-mapka-text{
    font-size: 18px;
  }
  .what-chaos-to-clarity{
    font-size: 18px;
  }
  .mapka-map-image {
    box-shadow: 0 0 0 0 #30353C;
    border-radius: 30px;
    position: relative;
    z-index: 1;
    /* Side fade us ing pseudo-elements */
  }
  .mapka-map-overlay-text {
    z-index: 3;
    color: #fff;
    border-radius: 18px;
    padding: 0 0 0 0;
  }
  .mapka-map-overlay-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px;
    letter-spacing: 0.5px;
  }
  .mapka-map-overlay-desc {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #e0e0e0;
  }
  .early-access-content{
    align-items: center !important;
  }
  .early-access-buttons {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  .early-access-right {
    position: absolute !important;
    right: 0;
    bottom: 0;
    width: 30vw;
  }
  .early-access-graphic {
    max-width: 100%;
    min-width: 80px;
    min-height: 80px;
  }
  .early-access-left {
    align-items: center;
    text-align: center;
  }
  .early-access-title {
    text-align: center;
  }
  .early-access-desc {
    text-align: center;
  }
  .early-access-buttons {
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 3rem;
  }
  .footer-newsletter{
    flex: none;
    display: flex;
    justify-content: flex-start;
  }
  .footer-col-title{
    font-size: 18px;
  }
  .footer-link{
    font-size: 16px;
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.18);
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.spinner {
  border: 6px solid rgba(19, 39, 117, 0.15);
  border-top: 6px solid #132775;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(19, 39, 117, 0.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #132775;
  font-size: 1.2rem;
  font-weight: 500;
  text-align: center;
}

/* FAQ Section Styles */
.faq-section {
  background: #ffffff;
  padding: 80px 0;
  min-height: 100vh;
}

.faq-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.faq-header {
  text-align: center;
  margin-bottom: 60px;
}

.faq-badge {
  background: rgba(244, 248, 255, 1);
  color: rgba(0,0,0,1);
  border: none;
  border-radius: 20px;
  padding: 8px 32px;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 20px;
}

.faq-title {
  font-size: 32px;
  font-weight: 700;
  color: rgba(0,0,0,1);
  margin: 0;
  text-align: center;
}

.faq-content {
  margin-bottom: 60px;
}

.faq-section-group {
  margin-bottom: 40px;
  border: 2px solid rgba(241, 241, 241, 1);
  border-radius: 25px;
  padding: 30px;
}

.faq-section-title {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0,0,0,1);
  margin-bottom: 20px;
  width: auto;
}

.faq-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  display: flex;
  align-items: flex-end;
}

.faq-item {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  justify-content: space-between;
  width: 80%;
}

.faq-question {
  width: 100%;
  background: none;
  border: none;
  padding: 20px 24px;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.faq-question:hover {
  background: #f0f0f0;
}

.faq-question.active {
  background: rgba(244, 248, 255, 1);
  position: relative;
}
.faq-chevron {
  transition: transform 0.3s ease;
  color: #666666;
}

.faq-chevron.rotated {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 0 24px 20px 24px;
  font-size: 15px;
  line-height: 1.6;
  color: #666666;
  background: rgba(244, 248, 255, 1);
}
.faq-disclaimer {
  text-align: center;
  font-size: 14px;
  color: #999999;
  line-height: 1.5;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
}

.faq-scroll-top {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  z-index: 1000;
}

.faq-scroll-top-btn {
  width: 50px;
  height: 50px;
  border: 2px solid #e0e0e0;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.faq-scroll-top-btn:hover {
  border-color: #cccccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.faq-scroll-top-btn svg {
  color: #333333;
}

.faq-scroll-top-label {
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  text-align: center;
}

/* Responsive FAQ Styles */
@media (max-width: 768px) {
  .faq-section {
    padding: 60px 0;
  }
  
  .faq-title {
    font-size: 36px;
    text-align: center;
  }
  
  .faq-question {
    padding: 16px 20px;
    font-size: 15px;
  }
  
  .faq-answer {
    padding: 0 20px 16px 20px;
    font-size: 14px;
  }
  
  .faq-disclaimer {
    font-size: 13px;
    padding: 16px 20px;
  }
}

@media (max-width: 480px) {
  .faq-title {
    font-size: 28px;
  }
  
  .faq-section-title {
    font-size: 18px;
  }
  
  .faq-question {
    padding: 14px 16px;
    font-size: 14px;
  }
  
  .faq-answer {
    padding: 0 16px 14px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LandingPage/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB,EAAE,4CAA4C;AACjE;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,+EAA+E;EAC/E,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,oEAAoE;;AAEpE;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;EACvB,+BAA+B;EAC/B,qDAAqD;EACrD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;;IAEE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,2CAA2C;EAC3C,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mFAAmF;AACrF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gGAAgG;AAClG;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,gCAAgC;EAClD,WAAW;EACX,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;EAChC;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,SAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,SAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,SAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;AACA;EACE,SAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EAEV,mEAAmE;AACrE;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;AACA;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,4DAA4D;EAC5D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,yCAAyC;IACzC,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,oCAAoC;IACpC,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,yCAAyC;IACzC,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,6BAA6B;IAC7B,QAAQ;IACR,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF","sourcesContent":[".landing-page{\n  background: linear-gradient(180deg, #FFFFFF 0%, #E7E7E7 100%);\n}\n\n#why {\n  scroll-margin-top: 250px;\n}\n\n#home, #what, #leadership, #products {\n  scroll-margin-top: 90px;\n}\n\n.landing-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n\n.hero-background {\n  color: white;\n  position: relative;\n  overflow: hidden;\n  overflow-x: hidden;\n  padding-top: 10px; /* Add padding to accommodate fixed navbar */\n}\n\n.landing-navbar {\n  padding: 1rem 0;\n  background-color: transparent !important;\n  transition: background-color 0.3s ease, padding 0.3s ease, box-shadow 0.3s ease;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.landing-navbar.scrolled {\n  padding: 0.5rem 0;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Styles for navbar when there are no messages (white background) */\n\n.landing-navbar.no-messages .navbar-brand {\n  color: #000 !important;\n}\n\n.landing-navbar.no-messages .main-nav .nav-link {\n  color: #000 !important;\n}\n\n.landing-navbar.no-messages .main-nav .nav-link:hover,\n.landing-navbar.no-messages .main-nav .nav-link.active {\n  color: #000 !important;\n}\n\n.landing-navbar.no-messages .login-btn {\n  background: transparent !important;\n  border: 2px solid #000 !important;\n  color: #000 !important;\n}\n\n.landing-navbar.no-messages .login-btn:hover {\n  background: #000 !important;\n  color: white !important;\n  border-color: #000 !important;\n}\n\n.navbar-container {\n  max-width: 1140px;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin: 0 auto;\n  width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.mapka-logo {\n  height: 50px !important;\n  width: auto;\n}\n\n.logo-text {\n  font-size: 32px;\n  font-weight: 600;\n  margin-left: 10px;\n  color: white;\n}\n\n/* Custom logo styling for the navbar */\n.navbar-brand {\n  font-size: 28px;\n  font-weight: 600;\n  color: white !important;\n  display: flex;\n  align-items: center;\n}\n\n.navbar-brand .logo-m {\n  background: linear-gradient(90deg, #ffffff 0%, #132775 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 700;\n  margin-right: 2px;\n}\n\n.navbar-brand .logo-text {\n  color: white;\n  font-weight: 400;\n  text-transform: lowercase;\n}\n\n.main-nav {\n  padding: 0;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.main-nav .nav-link {\n  color: white;\n  margin: 0 1.5rem;\n  padding: 0.5rem 0;\n  padding-left: 0 !important;\n  position: relative;\n  opacity: 0.8;\n  transition: opacity 0.3s ease;\n  font-weight: 400;\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.main-nav .nav-link:hover, \n.main-nav .nav-link.active {\n  opacity: 1;\n  color: white !important;\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.main-nav .nav-link.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 4px;\n  width: 50%;\n  background-color: white;\n  border-radius: 5px;\n}\n\n.nav-buttons {\n  display: flex;\n  gap: 15px;\n}\n\n.waitlist-btn {\n  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%);\n  border: none !important;\n  border-radius: 100px !important;\n  transition: background-color 0.3s ease, scale 1s ease;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.waitlist-btn:hover {\n  scale: 1.05;\n}\n\n.login-btn {\n  background: transparent !important;\n  border: 2px solid white !important;\n  color: white !important;\n  border-radius: 100px !important;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.login-btn:hover {\n  background: white !important;\n  color: #132775 !important;\n  border-color: white !important;\n}\n\n.hero-section {\n  padding: 8rem 0 4rem;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n}\n\n.powered-by {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  opacity: 0.8;\n}\n\n.powered-by span {\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.nysora-logo {\n  height: 20px;\n  width: auto;\n}\n\n.hero-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  line-height: 1.2;\n}\n\n.hero-description {\n  font-size: 1.5rem;\n  opacity: 0.8;\n  margin-bottom: 4rem;\n  line-height: 1.4;\n  font-weight: 400;\n}\n\n.scroll-indicator {\n  display: flex;\n  align-items: center;\n  opacity: 0.6;\n  font-size: 14px;\n  gap: 10px;\n}\n\n.hero-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.laptop-mockup {\n  position: absolute;\n  scale: 0.75;\n  z-index: 1;\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.why-description {\n  font-size: 1.25rem;\n  line-height: 1.6;\n  color: #555;\n}\n\n.landing-footer {\n  padding: 2rem 0;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n}\n\n.landing-footer a {\n  color: #6c757d;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.landing-footer a:hover {\n  color: #007bff;\n}\n\n@media (max-width: 1400px) {\n  .navbar-container {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  .main-nav .nav-link {\n    font-size: 16px;\n    margin-right: 1.2rem;\n  }\n  .nav-buttons .waitlist-btn,\n  .nav-buttons .login-btn {\n    font-size: 16px;\n    padding: 0.4rem 1.2rem;\n  }\n}\n\n@media (max-width: 1200px) {\n  .navbar-container {\n    flex-wrap: wrap;\n    gap: 0rem;\n  }\n  .main-nav .nav-link {\n    font-size: 16px;\n    margin-right: 0.6rem;\n  }\n  .nav-buttons .waitlist-btn,\n  .nav-buttons .login-btn {\n    font-size: 16px;\n    padding: 0rem 0rem;\n  }\n}\n\n@media (max-width: 991px) {\n  .main-nav {\n    margin-left: 0;\n    margin-bottom: 1rem;\n  }\n  \n  .main-nav .nav-link {\n    margin-right: 0;\n    margin-bottom: 0.5rem;\n  }\n  \n  .nav-buttons {\n    width: 100%;\n    justify-content: center;\n    margin-top: 1rem;\n  }\n  \n  .hero-section {\n    padding: 4rem 0 3rem;\n    text-align: center;\n  }\n  \n  .logo, .powered-by {\n    justify-content: center;\n  }\n  \n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-description {\n    font-size: 1.2rem;\n    margin-bottom: 2rem;\n  }\n  \n  .scroll-indicator {\n    justify-content: center;\n    margin-bottom: 3rem;\n  }\n\n  .section-header {\n    flex-direction: column;\n  }\n  \n  .section-header h2 {\n    margin-right: 0;\n    margin-bottom: 1rem;\n  }\n  \n  .section-divider {\n    width: 100%;\n  }\n}\n\n.klaviyo-form-section {\n  padding: 4rem 0;\n  background-color: #f8f9fa;\n}\n\n.klaviyo-form-container {\n  background: white;\n  border-radius: 16px;\n  padding: 3rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n}\n\n.klaviyo-form-container h3 {\n  font-weight: 600;\n  color: #30353C;\n  font-size: 2rem;\n}\n\n.klaviyo-form-container p {\n  color: #666;\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n/* Klaviyo form styling overrides */\n#klaviyo-form-embed .klaviyo-form {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n#klaviyo-form-embed input[type=\"email\"] {\n  border: 2px solid #e9ecef !important;\n  border-radius: 12px !important;\n  padding: 1rem 1.25rem !important;\n  font-size: 1rem !important;\n  transition: border-color 0.3s ease !important;\n}\n\n#klaviyo-form-embed input[type=\"email\"]:focus {\n  border-color: #2F80ED !important;\n  box-shadow: 0 0 0 0.2rem rgba(47, 128, 237, 0.15) !important;\n  outline: none !important;\n}\n\n#klaviyo-form-embed button[type=\"submit\"] {\n  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%) !important;\n  border: none !important;\n  border-radius: 100px !important;\n  padding: 1rem 2.5rem !important;\n  font-weight: 600 !important;\n  font-size: 1.1rem !important;\n  transition: transform 0.2s ease !important;\n  margin-top: 1rem !important;\n}\n\n#klaviyo-form-embed button[type=\"submit\"]:hover {\n  transform: translateY(-1px) !important;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .klaviyo-form-container {\n    padding: 2rem 1.5rem;\n    margin: 1rem;\n  }\n  \n  .klaviyo-form-container h3 {\n    font-size: 1.5rem;\n  }\n  \n  .klaviyo-form-container p {\n    font-size: 1rem;\n  }\n}\n\n.hero-orbit-bg {\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  width: 80vw;\n  max-width: 900px !important;\n  min-width: 400px;\n  transform: translate(-50%, -50%) scale(0.6);\n  z-index: 2;\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.hero-background {\n  position: relative;\n  overflow: hidden;\n}\n\n.scroll-indicator-vertical {\n  position: fixed;\n  top: 50%;\n  right: 40px;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 100;\n  pointer-events: none;\n}\n\n.scroll-dots {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  background: #D9D9D9;\n  border-radius: 50%;\n  opacity: 0.7;\n  transition: background 0.3s, opacity 0.3s, transform 0.4s cubic-bezier(0.4,0,0.2,1);\n}\n\n@media (max-width: 991px) {\n  .scroll-indicator-vertical {\n    display: none;\n  }\n}\n\n.indicator-line {\n  width: 8px;\n  height: 110px;\n  background: #D9D9D9;\n  border-radius: 6px;\n  margin: 2px 0;\n  opacity: 1;\n  transition: background 0.3s, height 0.3s, transform 0.4s cubic-bezier(0.4,0,0.2,1), opacity 0.3s;\n}\n\n.why-mapka-section {\n  width: 100%;\n  background: #30353C;\n  display: flex;\n  justify-content: center;\n}\n\n.why-mapka-title {\n  font-size: 40px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.why-mapka-divider {\n  width: 100%;\n  max-width: 120px; /* or whatever length you want */\n  height: 2px;\n  background: #fff; /* or your divider color */\n}\n\n.why-mapka-text {\n  font-size: 22px;\n  color: #fff;\n  margin: 0;\n  font-weight: 400;\n}\n\n.section-dots-divider {\n  border-top: 2px solid rgba(227, 227, 227, 1);\n  width: 100%;\n  opacity: 0.7;\n}\n\n@media (max-width: 900px) {\n  .why-mapka-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .why-mapka-title {\n    margin: 0 0 1.5rem 0;\n  }\n  .why-mapka-divider {\n    width: 100%;\n    margin: 0 0 1.5rem 0;\n    height: 2px;\n  }\n  .why-mapka-text {\n    max-width: 100%;\n  }\n}\n\n.what-section {\n  background: #30353C;\n  padding: 0rem 0 0rem 0;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.what-title-bg-wrapper {\n  position: relative;\n  width: 100%;\n  height: 0;\n  z-index: 1;\n}\n\n.what-title-bg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -70%);\n  font-size: 79px;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 1;\n  letter-spacing: 0px;\n  text-align: center;\n}\n\n.painpoint-cards-row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.painpoint-card {\n  border-radius: 20px;\n  color: #fff;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1.5rem 1.5rem 1.5rem 1.5rem;\n  margin-bottom: 2rem;\n  min-height: 320px;\n  border: 1px solid #949494;\n  transition: box-shadow 0.2s;\n  backdrop-filter: blur(40px);\n}\n.painpoint-card:hover {\n  box-shadow: 0 8px 32px rgba(47,128,237,0.12);\n}\n.painpoint-top {\n  font-size: 16px;\n  font-weight: 400;\n  opacity: 0.85;\n  margin-bottom: 2.5rem;\n  min-height: 48px;\n}\n.painpoint-bottom {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  justify-content: flex-start;\n  flex-grow: 0;\n}\n.painpoint-mapka-logo {\n  height: 32px;\n  width: auto;\n  margin-right: 0.5rem;\n}\n.painpoint-mapka-text {\n  font-size: 16px;\n  font-weight: 500;\n  color: #2F80ED;\n}\n.mapka-logo-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n.painpoint-solution {\n  font-size: 18px;\n  font-weight: 500;\n  color: #fff;\n  margin: 0;\n  align-self: flex-start;\n  line-height: 1.4;\n}\n.mapka-map-overlay-text {\n  color: #fff;\n}\n@media (max-width: 1200px) {\n  .painpoint-cards-row {\n    gap: 1.2rem;\n  }\n  .painpoint-card {\n    min-width: 170px;\n    max-width: 300px;\n    padding: 1.3rem 1rem 1rem 1rem;\n  }\n}\n@media (max-width: 900px) {\n  .painpoint-cards-row {\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n  }\n  .painpoint-card {\n    width: 100%;\n    max-width: 420px;\n    min-width: 0;\n  }\n  .what-section {\n    padding: 2.5rem 0 2rem 0;\n  }\n  .what-title {\n    font-size: 2rem;\n  }\n  .what-title-bg {\n    font-size: 9vw;\n  }\n}\n\n.what-chaos-to-clarity {\n  font-size: 22px;\n  font-weight: 400;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 4.5rem;\n  z-index: 2;\n  position: relative;\n}\n\n.gray-circles-right {\n  position: absolute;\n  bottom: 35%;\n  right: 0;\n  z-index: 1;\n  width: auto;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.gray-circles-img {\n  max-width: 320px !important;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n@media (max-width: 900px) {\n  .gray-circles-img {\n    max-width: 160px;\n  }\n}\n\n.what-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 3rem;\n}\n.what-image-col {\n  flex: 1 1 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 70%;\n}\n.what-mobiles-img {\n  width: 100%;\n  height: auto;\n  scale: 1.5;\n}\n.what-text-col {\n  flex: 1 1 0;\n  color: #fff;\n  padding-left: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 30%;\n}\n.what-text-col h2 {\n  font-size: 40px;\n  font-weight: 700;\n  text-align: right;\n}\n.what-text-col p {\n  font-size: 18px;\n  font-weight: 400;\n  text-align: right;\n  max-width: 450px;\n}\n@media (max-width: 900px) {\n  .what-content-row {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 0 0 0 0;\n  }\n  .what-image-col {\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n  .what-text-col {\n    padding-left: 0;\n    text-align: center;\n  }\n  .what-mobiles-img {\n    max-width: 90vw;\n  }\n}\n\n.leadership-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 3rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n.leadership-image-col {\n  flex: 1 1 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.leadership-mobiles-img {\n  max-width: 380px;\n  width: 100%;\n  height: auto;\n  border-radius: 32px;\n  box-shadow: 0 8px 32px rgba(47,128,237,0.10);\n}\n.leadership-text-col {\n  flex: 1 1 0;\n  color: #fff;\n  padding-left: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.leadership-text-col h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n}\n.leadership-text-col p {\n  font-size: 1.25rem;\n  line-height: 1.7;\n  color: #e0e0e0;\n}\n@media (max-width: 900px) {\n  .leadership-content-row {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 0 1rem;\n  }\n  .leadership-image-col {\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n  .leadership-text-col {\n    padding-left: 0;\n    text-align: center;\n  }\n  .leadership-mobiles-img {\n    max-width: 90vw;\n  }\n}\n\n.what-title-divider-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 3rem;\n}\n.what-title-divider-group .why-mapka-divider {\n  width: 100px;\n  max-width: 100%;\n  margin-right: 1rem;\n}\n\n.leadership-creed-section {\n}\n\n.leadership-creed-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  gap: 2.5rem;\n  padding: 0 2rem;\n}\n.leadership-creed-text-col {\n  flex: 1 1 0;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-width: 480px;\n}\n.leadership-creed-title {\n  font-size: 40px;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n}\n.leadership-creed-desc {\n  font-size: 18px;\n  font-weight: 400;\n  margin-bottom: 1.5rem;\n  color: #fff;\n}\n.leadership-creed-guiding {\n  font-size: 20px;\n  font-weight: 400;\n  margin-top: 1.5rem;\n}\n.leadership-creed-guiding span {\n  color: #fff;\n  font-weight: 500;\n}\n.leadership-creed-image-col {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n}\n.leadership-creed-img {\n  max-width: 100%;\n  height: auto;\n  z-index: 2;\n  -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n  mask-image: linear-gradient(to bottom, black 70%, transparent 100%);\n}\n.leadership-creed-name-title {\n  margin-top: 2.5rem;\n  text-align: right;\n  width: 100%;\n}\n.leadership-creed-name {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #fff;\n}\n.leadership-creed-role {\n  font-size: 1rem;\n  color: #e0e0e0;\n  margin-top: 0.2rem;\n}\n@media (max-width: 900px) {\n  .leadership-creed-row {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 0 0 0 0;\n  }\n  .leadership-creed-image-bg {\n    width: 220px;\n    height: 220px;\n  }\n  .leadership-creed-img {\n    width: 200px;\n  }\n  .leadership-creed-name-title {\n    margin-top: 1.2rem;\n    text-align: center;\n  }\n  .leadership-creed-text-col {\n    max-width: 100%;\n    text-align: center;\n  }\n}\n\n.human-first-section {\n  text-align: center;\n}\n.human-first-title {\n  font-size: 40px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 0.5rem;\n}\n.human-first-subtitle {\n  color: #fff;\n  font-size: 20px;\n  margin-bottom: 3.5rem;\n}\n.human-first-features-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 2.5rem;\n  margin: 0 auto;\n  max-width: 1200px;\n}\n.human-first-feature {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 200px;\n  max-width: 300px;\n}\n.human-first-icon-bg {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: #232733;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2rem;\n  backdrop-filter: blur(10px);\n  box-shadow: 0px 1px 50px 1px #2F80ED;\n  position: relative;\n}\n.human-first-icon {\n  color: #1a6cff;\n  font-size: 3rem;\n}\n.human-first-feature-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 1rem;\n  margin-top: 0.5rem;\n}\n.human-first-feature-desc {\n  color: #e0e0e0;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n@media (max-width: 900px) {\n  .human-first-features-row {\n    flex-direction: column;\n    gap: 2.5rem;\n    align-items: center;\n  }\n  .human-first-feature {\n    max-width: 100%;\n  }\n  .human-first-icon-bg {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 1.2rem;\n  }\n  .human-first-icon {\n    font-size: 2.2rem;\n  }\n}\n\n.products-section {\n}\n.products-title {\n  text-align: center;\n  color: #fff;\n  font-size: 40px;\n  font-weight: 700;\n  margin-bottom: 4rem;\n}\n.products-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n  gap: 4rem 4rem;\n  margin: 0 auto;\n}\n.products-stat {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n  gap: 2.5rem;\n  width: 100%;\n}\n.products-stat-number {\n  font-size: 145px;\n  font-weight: 300;\n  color: #fff;\n  text-align: right;\n  width: 50%;\n}\n.products-stat-plus {\n  font-size: 60px;\n  vertical-align: super;\n  font-weight: 400;\n}\n.products-stat-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 50%;\n}\n.products-stat-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 1rem;\n}\n.products-stat-desc {\n  font-size: 16px;\n  color: #fff;\n  font-weight: 400;\n}\n\n@media (max-width: 900px) {\n  .products-title {\n    font-size: 32px;\n  }\n  .products-stats-grid {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(4, 1fr);\n    gap: 2.5rem 0;\n  }\n  .products-stat {\n    gap: 1.5rem;\n  }\n  .products-stat-number {\n    font-size: 80px;\n    min-width: 60px;\n  }\n  .products-stat-title {\n    font-size: 18px;\n  }\n  .products-stat-desc {\n    font-size: 14px;\n  }\n}\n\n.mapka-footer {\n  color: #fff;\n  padding: 60px 0 30px 0;\n  position: relative;\n  margin-top: 0;\n}\n\n.footer-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 40px;\n  position: relative;\n}\n\n.footer-brand {\n  display: flex;\n  align-items: center;\n  flex: 1 1 180px;\n  margin-bottom: 30px;\n}\n\n.footer-logo {\n  max-width: 200px !important;\n  height: 50px !important; \n  margin-right: 12px;\n}\n.footer-links {\n  display: flex;\n  flex: 3 1 600px;\n  gap: 60px;\n  flex-wrap: wrap;\n}\n\n.footer-col {\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.footer-col-title {\n  color: #b0b3b8;\n  font-weight: 500;\n  margin-bottom: 8px;\n  font-size: 22px;\n}\n\n.footer-link {\n  color: #fff;\n  text-decoration: none;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 50px;\n  margin-bottom: 2px;\n  transition: color 0.2s;\n}\n\n.footer-link:hover {\n  opacity: 0.8;\n}\n\n.footer-newsletter {\n  flex: 2 1 300px;\n  min-width: 260px;\n}\n\n.footer-newsletter-title {\n  color: #868686;\n  font-weight: 600;\n  margin-bottom: 10px;\n  font-size: 22px;\n}\n\n.footer-newsletter-form {\n  display: flex;\n  align-items: center;\n}\n\n.footer-newsletter-input {\n  width: 100%;\n  padding: 10px 16px;\n  border-radius: 24px;\n  border: none;\n  background: #484b4e;\n  color: #fff;\n  font-size: 1rem;\n  outline: none;\n}\n\n.footer-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.footer-row-top {\n  margin-bottom: 40px;\n}\n\n.footer-row-bottom {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 40px;\n}\n\n.footer-scroll-top-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 0;\n}\n\n.footer-scroll-top {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footer-scroll-top svg {\n  display: block;\n  width: 70px;\n  height: 70px;\n}\n\n.footer-scroll-top-label {\n  color: #fff;\n  font-size: 1.1rem;\n  margin-top: 18px;\n  text-align: center;\n  opacity: 0.95;\n}\n\n.footer-scroll-top:hover svg circle {\n  fill: #3996d2;\n  transition: fill 0.2s;\n}\n\n@media (max-width: 900px) {\n  .footer-row,\n  .footer-row-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 30px;\n  }\n  .footer-scroll-top {\n    align-self: flex-end;\n    margin-top: 20px;\n  }\n}\n\n.footer-copyright {\n  width: 100%;\n  margin: 48px 0 0 0;\n  padding-bottom: 32px;\n}\n\n.footer-copyright-divider {\n  border: none;\n  border-top: 1.5px solid #5a5d60;\n  margin: 0 auto 32px auto;\n  width: 100%;\n  opacity: 0.4;\n}\n\n.footer-copyright-text {\n  color: #b0b3b8;\n  text-align: center;\n  font-size: 16px;\n  opacity: 0.7;\n  font-weight: 400;\n}\n\n.early-access-hero {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  max-width: 90vw;\n  margin: 0 auto 60px auto;\n  background: linear-gradient(90deg, #2F80ED 0%, #2D9EE0 100%);\n  border-radius: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 520px;\n}\n\n.early-access-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.early-access-left {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.early-access-title {\n  color: #fff;\n  font-size: 45px;\n  font-weight: 700;\n  margin-bottom: 24px;\n}\n\n.early-access-desc {\n  color: #eaf6ff;\n  font-size: 22px;\n  font-weight: 400;\n  margin-bottom: 40px;\n}\n\n.early-access-buttons {\n  display: flex;\n  gap: 24px;\n}\n\n.early-access-btn {\n  border: none;\n  border-radius: 100px;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 18px 44px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.early-access-btn.primary {\n  background: #fff;\n  color: #2D9BE1;\n  font-size: 18px;\n  padding: 18px 66px !important;\n}\n\n.early-access-btn.primary:hover {\n  background: rgba(255,255,255,0.2);\n  color: #fff;\n}\n\n.early-access-btn.secondary {\n  background: rgba(255,255,255,0.2);\n  color: #fff;\n  font-size: 18px;\n}\n\n.early-access-btn.secondary:hover {\n  background: rgba(255,255,255,0.3);\n}\n\n.early-access-right {\n  position: absolute !important;\n  right: 0;\n  bottom: 0;\n  height: auto;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  pointer-events: none;\n}\n\n.early-access-graphic {\n  max-width: 320px;\n  width: 100%;\n  height: auto;\n  min-width: 120px;\n  min-height: 120px;\n  max-height: 100%;\n}\n\n@media (max-width: 700px) {\n  section{\n    padding: 0rem 1rem 0rem 1rem;\n  }\n  .early-access-hero {\n    min-height: 420px;\n    padding-bottom: 120px;\n  }\n  .hero-section {\n    padding: 0 0 2rem 0;\n    min-height: 100vh;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n    position: relative;\n    z-index: 1;\n  }\n  .mobile-hero-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 18px 16px 0 16px;\n    position: relative;\n    z-index: 3;\n    background: transparent;\n  }\n  .mobile-logo {\n    display: flex;\n    align-items: center;\n    height: 40px;\n  }\n  .mobile-logo .mapka-logo {\n    height: 40px !important;\n    width: auto;\n  }\n  .mobile-hero-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-top: 0;\n    position: relative;\n    z-index: 2;\n  }\n  .mobile-scroll-indicator {\n    margin-top: 5rem;\n    text-align: center;\n    z-index: 2;\n    position: relative;\n    font-size: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n  }\n  .mobile-hero-image {\n    margin: 18px 0 0 0;\n    display: flex;\n    justify-content: center;\n    z-index: 1;\n    position: relative;\n    width: 100%;\n  }\n  .mobile-hero-image .laptop-mockup {\n    height: auto;\n    position: static;\n    scale: 1.2;\n  }\n  .mobile-hero-content {\n    margin: 18px 0 0 0;\n    text-align: center;\n    z-index: 2;\n    position: relative;\n    padding: 0 0 0 0;\n    width: 100%;\n  }\n  .mobile-hero-content .powered-by {\n    justify-content: center;\n    margin-bottom: 1.2rem;\n    margin-top: 0;\n    padding-top: 0 !important;\n  }\n  .mobile-hero-content .hero-title {\n    font-size: 22px;\n    margin-bottom: 1rem;\n  }\n  .mobile-hero-content .hero-description {\n    font-size: 16px;\n    margin-bottom: 1.5rem;\n  }\n  .powered-by span{\n    font-size: 12px;\n  }\n  .powered-by img{\n    height: 12px;\n  }\n  .painpoint-card{\n    max-width: 333px;\n    padding: 1.5rem 1.5rem 1.5rem 1.5rem;\n    margin-bottom: 0;\n  }\n  .hero-orbit-bg {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 100vw;\n    min-width: 600px;\n    max-width: 100vw;\n    height: 100vh;\n    transform: translateX(-50%);\n    z-index: 2;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n  .what-title-divider-group h2{\n    font-size: 22px;\n  }\n  .what-text-col{\n    width: 100%;\n  }\n  .what-text-col p{\n    text-align: left;\n  }\n  .what-title-divider-group h2{\n    text-align: left;\n  }\n  .what-mobiles-img{\n    scale: 1.4;\n    margin-top: 1rem;\n  }\n  .leadership-creed-row{\n    margin-top: 1rem;\n  }\n  .leadership-creed-title{\n    font-size: 22px;\n    text-align: left;\n  }\n  .leadership-creed-desc{\n    font-size: 16px;\n    text-align: left;\n  }\n  .leadership-creed-guiding{\n    font-size: 16px;\n    text-align: left;\n  }\n  .leadership-creed-img{\n    scale: 1.55;\n  }\n  .leadership-creed-section .section-dots-divider{\n    margin-top: 5rem !important;\n  }\n  .human-first-title{\n    font-size: 22px;\n  }\n  .human-first-subtitle{\n    font-size: 16px;\n  }\n  .human-first-features-row{\n    margin-top: 1rem;\n  }\n  .products-title{\n    font-size: 22px;\n  }\n  .products-stat-number{\n    display: flex;\n    justify-content: center;\n    width: 33% !important;\n  }\n  .mapka-map-image-wrapper{\n    margin-top: 1rem;\n  }\n  .early-access-right{\n    justify-content: flex-end;\n  }\n  .early-access-title{\n    font-size: 22px;\n    text-align: center;\n  }\n  .early-access-desc{\n    font-size: 16px;\n  }\n  .logo {\n    display: none !important;\n  }\n  .landing-navbar .navbar-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding-left: 10px;\n    padding-right: 10px;\n    overflow-x: hidden;\n    box-sizing: border-box;\n  }\n  .landing-navbar {\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    padding: 0.5rem 0;\n  }\n  .why-mapka-title{\n    font-size: 22px;\n  }\n  .why-mapka-divider{\n    display: none;\n  }\n  .why-mapka-text{\n    font-size: 16px;\n  }\n  .what-chaos-to-clarity{\n    font-size: 16px;\n  }\n  .mapka-map-image {\n    box-shadow: 0 0 0 0 #30353C;\n    border-radius: 30px;\n    position: relative;\n    z-index: 1;\n    /* Side fade using pseudo-elements */\n  }\n  .mapka-map-overlay-text {\n    z-index: 3;\n    color: #fff;\n    border-radius: 18px;\n    padding: 0 0 0 0;\n  }\n  .mapka-map-overlay-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-bottom: 10px;\n    letter-spacing: 0.5px;\n  }\n  .mapka-map-overlay-desc {\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #e0e0e0;\n  }\n  .early-access-content{\n    padding: 40px 10px 10px 10px;\n  }\n  .early-access-buttons {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  .early-access-right {\n    position: absolute !important;\n    right: 0;\n    bottom: 0;\n    width: 35vw;\n  }\n  .early-access-graphic {\n    max-width: 100%;\n    min-width: 80px;\n    min-height: 80px;\n  }\n  .early-access-left {\n    align-items: center;\n    text-align: center;\n  }\n  .early-access-title {\n    text-align: center;\n  }\n  .early-access-desc {\n    text-align: center;\n  }\n  .early-access-buttons {\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 3rem;\n  }\n  .footer-newsletter{\n    flex: none;\n  }\n  .footer-col-title{\n    font-size: 18px;\n  }\n  .footer-link{\n    font-size: 16px;\n  }\n}\n@media (max-width: 700px) {\n  .mapka-map-overlay-text {\n    top: 10px;\n    left: 10px;\n    max-width: 90vw;\n    padding: 0 0 0 0;\n  }\n  .mapka-map-overlay-title {\n    font-size: 1.1rem;\n  }\n  .mapka-map-overlay-desc {\n    font-size: 0.95rem;\n  }\n}\n\n.bg-map-section {\n  background-image: url('/public/bgmap2.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  z-index: 1;\n}\n\n@media (max-width: 991px) and (min-width: 701px) {\n  section{\n    padding: 0rem 1rem 0rem 1rem;\n  }\n  .early-access-hero {\n    min-height: 420px;\n    padding-bottom: 120px;\n  }\n  .hero-section {\n    padding: 0 0 2rem 0;\n    min-height: 100vh;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n    position: relative;\n    z-index: 1;\n  }\n  .mobile-hero-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 18px 16px 0 16px;\n    position: relative;\n    z-index: 3;\n    background: transparent;\n  }\n  .mobile-logo {\n    display: flex;\n    align-items: center;\n    height: 40px;\n  }\n  .mobile-logo .mapka-logo {\n    height: 40px !important;\n    width: auto;\n  }\n  .mobile-hero-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-top: 0;\n    position: relative;\n    z-index: 2;\n  }\n  .mobile-scroll-indicator {\n    margin-top: 5rem;\n    text-align: center;\n    z-index: 2;\n    position: relative;\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n  }\n  .mobile-hero-image {\n    margin: 18px 0 0 0;\n    display: flex;\n    justify-content: center;\n    z-index: 1;\n    position: relative;\n    width: 100%;\n  }\n  .mobile-hero-image .laptop-mockup {\n    height: auto;\n    position: static;\n    scale: 1;\n  }\n  .mobile-hero-content {\n    margin: 18px 0 0 0;\n    text-align: center;\n    z-index: 2;\n    position: relative;\n    padding: 0 0 0 0;\n    width: 100%;\n  }\n  .mobile-hero-content .powered-by {\n    justify-content: center;\n    margin-bottom: 1.2rem;\n    margin-top: 0;\n    padding-top: 0 !important;\n  }\n  .mobile-hero-content .hero-title {\n    font-size: 24px;\n    margin-bottom: 1rem;\n  }\n  .mobile-hero-content .hero-description {\n    font-size: 18px;\n    margin-bottom: 1.5rem;\n  }\n  .powered-by span{\n    font-size: 13px;\n  }\n  .powered-by img{\n    height: 12px;\n  }\n  .painpoint-card{\n    max-width: 333px;\n    padding: 1.5rem 1.5rem 1.5rem 1.5rem;\n    margin-bottom: 0;\n  }\n  .hero-orbit-bg {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 100vw;\n    min-width: 600px;\n    max-width: 100vw;\n    height: 100vh;\n    transform: translateX(-50%);\n    z-index: 2;\n    opacity: 0.5;\n    pointer-events: none;\n  }\n  .what-title-divider-group h2{\n    font-size: 22px;\n  }\n  .what-text-col{\n    width: 100%;\n    align-items: center !important;\n  }\n  .what-text-col p{\n    text-align: left;\n  }\n  .what-title-divider-group h2{\n    text-align: left;\n  }\n  .what-mobiles-img{\n    scale: 1.4;\n    margin-top: 4rem;\n  }\n  .leadership-creed-row{\n    margin-top: 1rem;\n  }\n  .leadership-creed-title{\n    font-size: 24px;\n    text-align: left;\n  }\n  .leadership-creed-desc{\n    font-size: 18px;\n    text-align: left;\n  }\n  .leadership-creed-guiding{\n    font-size: 18px;\n    text-align: left;\n  }\n  .leadership-creed-img{\n    scale: 1.85;\n  }\n  .leadership-creed-section .section-dots-divider{\n    margin-top: 5rem !important;\n  }\n  .human-first-title{\n    font-size: 24px;\n  }\n  .human-first-subtitle{\n    font-size: 18px;\n  }\n  .human-first-features-row{\n    margin-top: 1rem;\n  }\n  .products-title{\n    font-size: 24px;\n  }\n  .products-stat-number{\n    display: flex;\n    justify-content: center;\n    width: 33% !important;\n  }\n  .mapka-map-image-wrapper{\n    margin-top: 1rem;\n  }\n  .early-access-right{\n    justify-content: flex-end;\n  }\n  .early-access-title{\n    font-size: 24px;\n    text-align: center;\n  }\n  .early-access-desc{\n    font-size: 18px;\n  }\n  .logo {\n    display: none !important;\n  }\n  .landing-navbar .navbar-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding-left: 10px;\n    padding-right: 10px;\n    overflow-x: hidden;\n    box-sizing: border-box;\n  }\n  .landing-navbar {\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    padding: 0.5rem 0;\n  }\n  .why-mapka-title{\n    font-size: 24px;\n  }\n  .why-mapka-divider{\n    display: none;\n  }\n  .why-mapka-text{\n    font-size: 18px;\n  }\n  .what-chaos-to-clarity{\n    font-size: 18px;\n  }\n  .mapka-map-image {\n    box-shadow: 0 0 0 0 #30353C;\n    border-radius: 30px;\n    position: relative;\n    z-index: 1;\n    /* Side fade us ing pseudo-elements */\n  }\n  .mapka-map-overlay-text {\n    z-index: 3;\n    color: #fff;\n    border-radius: 18px;\n    padding: 0 0 0 0;\n  }\n  .mapka-map-overlay-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    letter-spacing: 0.5px;\n  }\n  .mapka-map-overlay-desc {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #e0e0e0;\n  }\n  .early-access-content{\n    align-items: center !important;\n  }\n  .early-access-buttons {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  .early-access-right {\n    position: absolute !important;\n    right: 0;\n    bottom: 0;\n    width: 30vw;\n  }\n  .early-access-graphic {\n    max-width: 100%;\n    min-width: 80px;\n    min-height: 80px;\n  }\n  .early-access-left {\n    align-items: center;\n    text-align: center;\n  }\n  .early-access-title {\n    text-align: center;\n  }\n  .early-access-desc {\n    text-align: center;\n  }\n  .early-access-buttons {\n    flex-direction: column;\n    gap: 16px;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 3rem;\n  }\n  .footer-newsletter{\n    flex: none;\n    display: flex;\n    justify-content: flex-start;\n  }\n  .footer-col-title{\n    font-size: 18px;\n  }\n  .footer-link{\n    font-size: 16px;\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0,0,0,0.18);\n  z-index: 99999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner {\n  border: 6px solid rgba(19, 39, 117, 0.15);\n  border-top: 6px solid #132775;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 18px;\n  box-shadow: 0 2px 8px rgba(19, 39, 117, 0.1);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  color: #132775;\n  font-size: 1.2rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* FAQ Section Styles */\n.faq-section {\n  background: #ffffff;\n  padding: 80px 0;\n  min-height: 100vh;\n}\n\n.faq-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.faq-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.faq-badge {\n  background: rgba(244, 248, 255, 1);\n  color: rgba(0,0,0,1);\n  border: none;\n  border-radius: 20px;\n  padding: 8px 32px;\n  font-size: 12px;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.faq-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: rgba(0,0,0,1);\n  margin: 0;\n  text-align: center;\n}\n\n.faq-content {\n  margin-bottom: 60px;\n}\n\n.faq-section-group {\n  margin-bottom: 40px;\n  border: 2px solid rgba(241, 241, 241, 1);\n  border-radius: 25px;\n  padding: 30px;\n}\n\n.faq-section-title {\n  font-size: 20px;\n  font-weight: 500;\n  color: rgba(0,0,0,1);\n  margin-bottom: 20px;\n  width: auto;\n}\n\n.faq-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  display: flex;\n  align-items: flex-end;\n}\n\n.faq-item {\n  background: #f8f9fa;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  justify-content: space-between;\n  width: 80%;\n}\n\n.faq-question {\n  width: 100%;\n  background: none;\n  border: none;\n  padding: 20px 24px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: 500;\n  color: #333333;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.faq-question:hover {\n  background: #f0f0f0;\n}\n\n.faq-question.active {\n  background: rgba(244, 248, 255, 1);\n  position: relative;\n}\n.faq-chevron {\n  transition: transform 0.3s ease;\n  color: #666666;\n}\n\n.faq-chevron.rotated {\n  transform: rotate(180deg);\n}\n\n.faq-answer {\n  padding: 0 24px 20px 24px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #666666;\n  background: rgba(244, 248, 255, 1);\n}\n.faq-disclaimer {\n  text-align: center;\n  font-size: 14px;\n  color: #999999;\n  line-height: 1.5;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px 0;\n}\n\n.faq-scroll-top {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  z-index: 1000;\n}\n\n.faq-scroll-top-btn {\n  width: 50px;\n  height: 50px;\n  border: 2px solid #e0e0e0;\n  border-radius: 50%;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.faq-scroll-top-btn:hover {\n  border-color: #cccccc;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.faq-scroll-top-btn svg {\n  color: #333333;\n}\n\n.faq-scroll-top-label {\n  font-size: 12px;\n  color: #999999;\n  font-weight: 400;\n  text-align: center;\n}\n\n/* Responsive FAQ Styles */\n@media (max-width: 768px) {\n  .faq-section {\n    padding: 60px 0;\n  }\n  \n  .faq-title {\n    font-size: 36px;\n    text-align: center;\n  }\n  \n  .faq-question {\n    padding: 16px 20px;\n    font-size: 15px;\n  }\n  \n  .faq-answer {\n    padding: 0 20px 16px 20px;\n    font-size: 14px;\n  }\n  \n  .faq-disclaimer {\n    font-size: 13px;\n    padding: 16px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .faq-title {\n    font-size: 28px;\n  }\n  \n  .faq-section-title {\n    font-size: 18px;\n  }\n  \n  .faq-question {\n    padding: 14px 16px;\n    font-size: 14px;\n  }\n  \n  .faq-answer {\n    padding: 0 16px 14px 16px;\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
